import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { EMPTY, take } from 'rxjs';

@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.scss'],
})
export class PersonalInfoComponent implements OnInit {
  @Input() userUID: string | undefined;
  personalInfo: any;
  personal = '../../../../assets/images/user (1).png';
  constructor(private firestore: AngularFirestore) {}

  ngOnInit(): void {
    this.getPersonalInfo();
  }

  getPersonalInfo() {
    this.firestore
      .collection('personalInfo')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        let obj = data.data();
        obj.firstName = obj.firstName + ' ' + obj.lastName;
        this.personalInfo = obj;
      });
  }
}
